import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { OfferCardComponent } from 'src/app/components/offer-card/offer-card.component';
import { PaginationComponent } from 'src/app/components/pagination/pagination.component';
import { Offer } from '../../../../models/offer';
import { Paginated } from '../../../../models/papginated';
import { OfferLikeService } from '../../../../services/offer-like.service';

@Component({
    selector: 'app-profile-tab-liked-offers',
    templateUrl: './profile-tab-liked-offers.page.html',
    styleUrls: ['./profile-tab-liked-offers.page.scss'],
    standalone: true,
    imports: [CommonModule, TranslatePipe, LoaderComponent, OfferCardComponent, PaginationComponent],
})
export class ProfileTabLikedOffersPage implements OnInit, OnDestroy {
    offers: Paginated<Offer> = { items: [], total: 0, page: 1, perPage: 15 };
    loading = true;
    private routerSubscription: Subscription;

    constructor(
        private readonly offerLikeService: OfferLikeService,
        private readonly router: Router,
    ) {}

    ngOnInit() {
        this.loadOffers(1);

        this.routerSubscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                if (event.urlAfterRedirects === '/profile/liked-offers') {
                    this.loadOffers(this.offers.page);
                }
            });
    }

    ngOnDestroy() {
        this.routerSubscription?.unsubscribe();
    }

    pageChanged(page: number) {
        this.loadOffers(page);
    }

    private loadOffers(page: number) {
        this.loading = true;
        this.offerLikeService.getLiked(page, this.offers.perPage).subscribe({
            next: (result) => {
                if (result.items.length === 0 && result.page > 1 && result.total > 0) {
                    this.loadOffers(result.page - 1);
                    return;
                }
                this.offers = result;
                this.loading = false;
            },
            error: () => {
                this.offers = { items: [], total: 0, page: 1, perPage: this.offers.perPage };
                this.loading = false;
            },
        });
    }
}
